export const trackEvent = ({ action, category, label, value }) => {
  if (!window.gtag) return;

  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

export const handleAnalyticsClick = (category, label, action = "click") => {
  trackEvent({ action, category, label });
};
